export type JsonContainer = Record<string, unknown> | unknown[];

export const isJsonContainer = (value: unknown): value is JsonContainer =>
  value !== null && typeof value === 'object';

export const isStringifiedJson = (value: string): boolean => {
  if (!value) {
    return false;
  }

  const firstChar = value[0];
  const lastChar = value[value.length - 1];

  return (
    (firstChar === '{' && lastChar === '}') ||
    (firstChar === '[' && lastChar === ']')
  );
};

export const tryParseJsonObject = (value: string): JsonContainer | null => {
  if (!isStringifiedJson(value)) {
    return null;
  }

  try {
    const parsedValue = JSON.parse(value);

    if (isJsonContainer(parsedValue)) {
      return parsedValue;
    }
  } catch {
    return null;
  }

  return null;
};
